import { JogetClient } from "../data/jogetClient";

export const getDropdowns = (pageSize = 120) => {
  return JogetClient.get(import.meta.env.VITE_API_DROPDOWNS, {
    params: { pageSize },
  });
};
